<template>
  <ReportBaseSelectFilter
    class="time-off-policy-filter"
    label="Policy"
    placeholder="All policies"
    :options="allTimeOffPolicies"
    query-property="time_off_policies"
  />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ReportTimeOffPolicyFilter',
  computed: {
    ...mapGetters(['allTimeOffPolicies']),
  },
};
</script>
